import { apiFetch } from "./client";
import type { Page } from "./types";
import type { ListParams } from "./customers";

export interface Trailer {
  id: number;
  trailer_number: string;
  haulier_id: number;
  is_double_deck: boolean;
}

export async function listTrailers(params: ListParams = {}): Promise<Page<Trailer>> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  const query = qs.toString();
  return apiFetch<Page<Trailer>>(`/trailers${query ? `?${query}` : ""}`);
}
